/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import Tabs from './Components/Tabs/Tabs'
import TemplateSelector from 'container/pages/Home/components/ImageGeneration/components/TemplateSelector'
import theme from 'container/theme';
import { useDispatch, useSelector } from 'react-redux'
import assets from 'assets'
import Switch from 'container/components/Switch/Switch';
import Select from 'container/components/Select/Select';
import { imageDimensions, imageGenerationModels } from 'app.config'
import { validate } from 'container/utils/validations';
import { number, object } from 'yup'
import RangeInput from 'container/pages/Home/components/ImageGeneration/components/RangeInput'
import Checkbox from 'container/components/Checkbox/Checkbox'
import ModelDropdown from './Components/ModelDropdown/ModelDropdown'
import StatusDropdown from './Components/StatusDropdown/StatusDropdown'
import ConversationList from './Components/ConversationList/ConversationList';
import { config } from 'container/data/models';
import { createConvesation, images_history } from 'container/api';
import PromptDetail from 'container/pages/Home/components/ImageGeneration/PromptDetail/PromptDetail';

const schema = object({
    height: number().min(90).max(2800).required(),
    width: number().min(90).max(2800).required(),
});

const CreateImage = () => {

    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState('Generate')
    const [showAdvanced, setShowAdvanced] = useState(false)
    const [dSelectorValue, setDSelectorValue] = useState('');
    const { selectedFilter, grid, model, prompt_strength, seed, keepSeed,
        filters, imageCount, neg_prompt, loading, width, height,
        templates, promptEdited, selectedTemplate, selectedImage
    } = useSelector(state => state.imageGeneration);
    const [showExclude, setShowExclue] = useState(false);
    const [customDimension, setCustomDimension] = useState(true);
    const [dimensionsError, setDimensionsError] = useState('');
    const [random, setRandom] = useState(false);

    const artist_options = [
        {
            label: 'Frida Kahlo',
            img: assets.FridaKahlo,
            style: `8k portrait influenced by Frida Kahlo's 'Surrealism,' with symbolic elements, vibrant colours, and introspective themes.`
        },
        {
            label: 'Henri Matisse',
            img: assets.HenriMatisse,
            style: `8k portrait in the style of Henri Matisse's 'Fauvism,' with bold colours, simplified forms, and expressive brushwork`
        },
        {
            label: 'Jackson Pollock',
            img: assets.JacksonPollock,
            style: `8k portrait in the style of Jackson Pollock's 'Abstract Expressionism,' featuring drips, splatters, and energetic brushwork.`
        },
        {
            label: 'Salvador Dali',
            img: assets.SalvadorDali,
            style: `8k portrait influenced by Salvador Dalí's 'Surrealism,' featuring unexpected juxtapositions, melting objects, and a dreamlike atmosphere.`
        },


        {
            label: 'Wassily Kandinsky',
            img: assets.WassilyKandinsky,
            style: `8k portrait inspired by Wassily Kandinsky's 'Abstract Art,' featuring geometric shapes, vibrant colours, and spiritual themes.`
        },
    ]
    const [selectedArtist, setSelectedArtist] = useState(null)

    const selectedModel = useSelector(state => state.chat.model);
    const [sortedConversations, setSortedConversations] = useState([]);
    const [conversations, setConversations] = useState([])
    const { selectedConversation, timeFilter } = useSelector(state => state.chat);

    const [Promt, setPromt] = useState("")
    const sortArray = async () => {
        const sortedConvoArray = await sortArrayByLatestDate([...conversations]);
        setSortedConversations([...sortedConvoArray]);
        // await sortArrayByLatestDate([...conversations])
        // setSortedConversations([]);
    };

    useEffect(() => {
        sortArray();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [conversations]);

    useEffect(() => {
        
        dispatch.imageGeneration.getUserImages("all");
    }, [])

    useEffect(() => {
        imageHistory();
    }, [])

    const imageHistory = async () => {
        const res = await images_history();

        if (res.data.status === 200) {
            setConversations(res.data.data)
        }
    }
    

    // useEffect(() => {
    //     if (model) {
    //         let query = `?model=picasso`;
    //         if (timeFilter === 'recent') {
    //             query += `&most_recent=true`;
    //         } else if (timeFilter === 'favourite') {
    //             query += `&favourite=true`;
    //         }
    //         setTimeout(() => {
    //             dispatch.chat.getAllConversations(query);
    //         }, 100);
    //     }
    //     // eslint-disable-next-line
    // }, [timeFilter, model]);
    

    const sortArrayByLatestDate = arr => {
        return arr.sort((a, b) => {
            const dateA = new Date(a.updated_at);
            const dateB = new Date(b.updated_at);

            return dateB - dateA;
        });
    };

    const handleOnSelect = name => {
        const filter = filters.find(f => f.name === name);
        console.log(filter);
        dispatch.imageGeneration.setSelectedFilter(filter);
    };

    const handleNegativePrompt = e => {
        dispatch.imageGeneration.setNegPrompt(e.currentTarget.value);
    };

    const handleDimensionChange = e => {
        const value = e.target.value;
        if (value === 'custom') {
            setDSelectorValue(value);
            return setCustomDimension(true);
        } else {
            setCustomDimension(false);
        }
        const dimensions = value?.split(' x ');
        dispatch.imageGeneration.setWidth(+dimensions[0]);
        dispatch.imageGeneration.setHeight(+dimensions[1]);
        setDSelectorValue(value);
    };

    const handleDimensions = e => {
        const { name, value } = e.currentTarget;
        if (name === 'width') {
            dispatch.imageGeneration.setWidth(+value);
        } else {
            dispatch.imageGeneration.setHeight(+value);
        }
    };

    const validateDimensions = async () => {
        const errors = await validate(schema, { height, width });
        if (errors) {
            const errorMessages = Object?.keys(errors).map(msg => errors[msg]);
            setDimensionsError(errorMessages.join('. '));
            dispatch.imageGeneration.setDisable(true);
        } else {
            setDimensionsError('');
            dispatch.imageGeneration.setDisable(false);
        }
    };

    const handleImageCount = count => {
        dispatch.imageGeneration.setImageCount(count);
    };

    const handleChangeModel = value => {
        dispatch.imageGeneration.setModel(value);
    };

    const handlePromptStrength = e => {
        dispatch.imageGeneration.setPromptStrength(+e.currentTarget.value);
    };

    useEffect(() => {
        if (width === 0) {
            dispatch.imageGeneration.setWidth('');
        }
        if (height === 0) {
            dispatch.imageGeneration.setHeight('');
        }

        validateDimensions();
        // eslint-disable-next-line
    }, [width, height]);



   
    const handlePredict = async () => {
        try {
            dispatch.imageGeneration.setLoading(true);
            dispatch.imageGeneration.setFinalPrompt(Promt)
            let conversationId = selectedConversation?.id;
            if (!selectedConversation) {
                const { data } = await createConvesation({
                    label: Promt,
                    model: 'picasso',
                });
                conversationId = data?.payload?.id;
                let query = `?model=${selectedModel.value}`;
                if (timeFilter === 'recent') {
                    query += `&most_recent=true`;
                } else if (timeFilter === 'favourite') {
                    query += `&favourite=true`;
                }

                dispatch.chat.getAllConversations(query);
                dispatch.chat.setSelectedConversation(data.payload);
                dispatch.chat.setSelectedImage(null)
            }

            dispatch.imageGeneration.generateImage({
                prompt: Promt,
                conversation_id: conversationId,
                steps: 50,
                width: width,
                height: height,
                images: imageCount,
                prompt_strength: prompt_strength,
                enhance_prompt: 0,
                restore_faces: 1,
                model_id: model,
                negative_prompt: neg_prompt,
                seed: seed || '',
            });
            dispatch.chat.setMobileScreen('chat')
            dispatch.imageGeneration.setSeed('');
            dispatch.imageGeneration.setSelectedFilter(null);
            dispatch.imageGeneration.setSelectedImage(null);
            dispatch.imageGeneration.setFinalPrompt('');
            dispatch.imageGeneration.setCustomPrompt('');
            setPromt('');
            dispatch.imageGeneration.setIsPromptDetail(false);
            setSelectedArtist(null)
        } catch (err) {
            console.log(err.message);
        } finally {
        }
    };


    const getIcon = model => {
        const data = config.find(item => item.value === model);
        return (
            <img
                src={data?.image}
                alt={data?.value}
                style={{
                    width: '20px',
                    height: '20px',
                    borderRadius: '5px',
                    marginTop: '-2px',
                }}
            />
        );
    };

    const handleTemplateSelect = val => {
        dispatch.imageGeneration.setSelectedTemplate(val);
        dispatch.imageGeneration.setPromptEdited(false);
        dispatch.imageGeneration.setIsPromptDetail(true);
        
    };

    useEffect(() => {
        let query = '';
        
        if (selectedArtist) {
            query = selectedArtist.style;
        }
        
        if (selectedImage) {
            query += selectedImage.prompt;
        }
        if (selectedFilter?.descrption?.length) {
            query = query + ' and ' + selectedFilter.descrption;
        }
        // if (filterEdited && step > 2) {
        //     query = finalPrompt;
        // }
        setPromt(query);
        // eslint-disable-next-line
    }, [selectedImage, selectedFilter, selectedArtist]);
    return (
        <Container>
            <PromptDetail />
            <div>
                <Tabs activeTab={activeTab} setActiveTab={setActiveTab} />
            </div>
            <ModelDropdown
                options={imageGenerationModels}
                onChange={handleChangeModel}
                value={imageGenerationModels.find(x => x.value.trim() === model.trim())}
            />

            {/* Generate Tab */}
            {activeTab === "Generate" && (<>

                <div className='padding-15'>
                    <DimensionButtons>
                        <Button
                            className={`ba-btn ${showAdvanced ? '' : 'active'}`}
                            onClick={() => setShowAdvanced(false)}
                            id='basic'
                        >
                            Basic
                        </Button>
                        <Button
                            className={`ba-btn ${showAdvanced ? 'active' : ''}`}
                            onClick={() => setShowAdvanced(true)}
                            id='advanced'
                        >
                            Advanced
                        </Button>
                    </DimensionButtons>

                    <Divider />
                </div>

                <Content>

                    <div>
                        <p className='font-size-16'>Select a template</p>
                        <p className='subtitle font-size-10'>
                            Choose to create a custom image using a text prompt or select a pre-made image template to begin.
                        </p>
                        <div className='temp-selector'>
                            <TemplateSelector
                                containerStyles={{
                                    backgroundColor: theme.colors.darkgray,
                                }}
                                onSelect={handleTemplateSelect}
                                options={Object.keys(templates).map(template => ({
                                    img: templates[template || 'Art'][0].example_image_url,
                                    label: template,
                                }))}
                                selected={{
                                    img: promptEdited
                                        ? assets.custom
                                        : selectedTemplate
                                            ? selectedTemplate === 'custom'
                                                ? assets.custom
                                                : templates[selectedTemplate || 'Art'][0].example_image_url
                                            : assets.custom,
                                    label: promptEdited
                                        ? 'Custom prompt'
                                        : selectedTemplate || 'Select an option',
                                }}
                            />
                        </div>

                        <DividerSpan>
                            <span>OR</span>
                        </DividerSpan>
                    </div>

                    {/* <div>
                        <p className='font-size-16'>Art styles</p>
                        <p className='subtitle font-size-10'>
                            Experiment with different art styles to apply to your image.
                        </p>
                        <div className='temp-selector'>
                            <TemplateSelector
                                containerStyles={{
                                    backgroundColor: theme.colors.darkgray,
                                }}
                                onSelect={handleTemplateSelect}
                                options={Object.keys(templates).map(template => ({
                                    img: templates[template || 'Art'][0].example_image_url,
                                    label: template,
                                }))}
                                selected={{
                                    img: promptEdited
                                        ? assets.custom
                                        : selectedTemplate
                                            ? selectedTemplate === 'custom'
                                                ? assets.custom
                                                : templates[selectedTemplate || 'Art'][0].example_image_url
                                            : assets.custom,
                                    label: promptEdited
                                        ? 'Custom prompt'
                                        : selectedTemplate || 'Select an option',
                                }}
                            />
                        </div>

                        <DividerSpan>
                            <span>OR</span>
                        </DividerSpan>
                    </div> */}

                    <div>
                        <p className='font-size-16'>Artist</p>
                        <p className='subtitle font-size-10'>
                            Select from a list of artists and copy their styles.
                        </p>
                        <div className='temp-selector'>
                            <TemplateSelector
                                containerStyles={{
                                    backgroundColor: theme.colors.darkgray,
                                }}
                                onSelect={(val) => {
                                    const findedArtist = artist_options.find(x => x.label.trim() === val.trim())
                                    setSelectedArtist(findedArtist)
                                }}
                                options={artist_options}
                                selected={selectedArtist || {
                                    img: assets.custom,
                                    label:'Select an option',
                                }}
                            />
                        </div>

                        <DividerSpan>
                            <span>OR</span>
                        </DividerSpan>
                    </div>

                    <div>
                        <p className='font-size-16'>Enter Prompt</p>
                        <p className='subtitle font-size-10'>
                            You can use a single word or a full sentence about what you want to generate.
                        </p>

                        <TextArea
                            placeholder='Describe image to generate'
                            value={Promt}
                            onChange={e => setPromt(e.target.value)}
                            rows={5}
                        ></TextArea>
                    </div>

                    <Divider />

                    <div id='step-4'>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                            }}
                        >
                            <p className='font-size-16'>Exclude from image</p>
                            <Switch
                                checked={showExclude}
                                onChange={e => setShowExclue(e.target.checked)}
                            />
                        </div>

                        {showExclude && (
                            <>
                                <p className='subtitle font-size-10'>
                                    Describe details you don’t want in your image like color,
                                    objects or a scenery.
                                </p>
                                <TextArea
                                    placeholder='goldfish, pink, blurry'
                                    value={neg_prompt}
                                    onChange={handleNegativePrompt}
                                    rows={5}
                                ></TextArea>
                            </>
                        )}
                    </div>

                    <Divider />

                    <div id='step-3'>
                        <p className='font-size-16'>Filter</p>
                        <p className='subtitle font-size-10'>
                            Experiment with different styles that can be applied to your image.
                        </p>
                        <div className='temp-selector'>
                            <TemplateSelector
                                containerStyles={{
                                    backgroundColor: theme.colors.darkgray,
                                }}
                                selected={{
                                    img: selectedFilter?.image_url || assets.preview,
                                    label: selectedFilter?.name || 'Select',
                                }}
                                onSelect={handleOnSelect}
                                options={
                                    filters.length
                                        ? filters.map(filter => ({
                                            img: filter.image_url,
                                            label: filter.name,
                                        }))
                                        : []
                                }
                            />
                        </div>
                    </div>

                    <Divider />

                    <div id='step-5'>
                        <p className='font-size-16'>Image Dimensions</p>
                        <p className='subtitle font-size-10'>Width x Height of the image.</p>

                        <div style={{ marginBlock: '20px' }}>
                            <Select
                                value={dSelectorValue}
                                onChange={handleDimensionChange}
                                options={imageDimensions}
                            />
                        </div>

                        {customDimension && (
                            <>
                                <p className='subtitle font-size-10'>Custom dimensions</p>
                                <CustomDimensions>
                                    <Input
                                        placeholder='Add width'
                                        type='number'
                                        value={width}
                                        name='width'
                                        onChange={handleDimensions}
                                        min={90}
                                        max={1024}
                                        className={dimensionsError ? 'error' : ''}
                                    />
                                    <Input
                                        placeholder='Add height'
                                        type='number'
                                        name='height'
                                        value={height}
                                        onChange={handleDimensions}
                                        min={90}
                                        max={1024}
                                        className={dimensionsError ? 'error' : ''}
                                    />
                                </CustomDimensions>
                            </>
                        )}
                        {dimensionsError && (
                            <p className='font-size-12 error-message'>
                                Dimensions must be between 90 and 2800
                            </p>
                        )}

                    </div>

                    <Divider />

                    <div id='step-6'>
                        <p className='font-size-16'>Number of images</p>
                        <p className='subtitle font-size-10'>
                            Select the number of images you would like to generate.
                        </p>
                        <ImageCountGrid>
                            <Button
                                className={imageCount === 1 ? 'active' : ''}
                                onClick={() => handleImageCount(1)}
                                disabled={loading}
                            >
                                1
                            </Button>
                            <Button
                                className={imageCount === 2 ? 'active' : ''}
                                onClick={() => handleImageCount(2)}
                                disabled={loading}
                            >
                                2
                            </Button>
                            <Button
                                className={imageCount === 3 ? 'active' : ''}
                                onClick={() => handleImageCount(3)}
                                disabled={loading}
                            >
                                3
                            </Button>
                            <Button
                                className={imageCount === 4 ? 'active' : ''}
                                onClick={() => handleImageCount(4)}
                                disabled={loading}
                            >
                                4
                            </Button>
                        </ImageCountGrid>
                    </div>

                    <Divider />

                    {showAdvanced && (
                        <>
                            <Divider />
                            <p className='font-size-16'>Columns</p>
                            <p className='subtitle font-size-10'>
                                Choose number of columns to display in viewer.
                            </p>
                            <RangeInput
                                value={grid}
                                min={1}
                                max={3}
                                onChange={e => {
                                    dispatch.imageGeneration.setGrid(e.target.value);
                                }}
                            />

                            <Divider />
                            <p className='font-size-16'>Prompt Guidance</p>
                            <p className='subtitle font-size-10'>
                                Higher values will make your image closer to your prompt.
                            </p>
                            <div className='select-container'>
                                <RangeInput
                                    min={7}
                                    max={30}
                                    value={prompt_strength}
                                    onChange={handlePromptStrength}
                                />
                            </div>
                            {/* <Divider />
                                <p className='font-size-16'>Model</p>
                                <p className='subtitle font-size-10'>
                                    Different AI models can produce different or better results so
                                    feel free to experiment.
                                </p>
                                <div className='select-container'>
                                    <Select
                                        options={imageGenerationModels}
                                        onChange={handleChangeModel}
                                        value={model}
                                    />
                                </div> */}
                            <Divider />
                            <div className='flex justify-content-between'>
                                <p className='font-size-16'>Seed</p>
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        color: 'var(--new-bg-color)',
                                        gap: '10px'
                                    }}
                                >
                                    <p className='font-size-10'>Random</p>
                                    <Switch
                                        checked={random}
                                        onChange={e => setRandom(e.target.checked)}
                                    />
                                </div>
                            </div>
                            <p className='subtitle font-size-10'>
                                Different numbers result in new variations of your image.
                            </p>

                            <Input
                                value={seed}
                                onChange={e => dispatch.imageGeneration.setSeed(e.target.value)}
                            />

                            <div className='flex-row gap-10'>
                                <Checkbox
                                    checked={keepSeed}
                                    onChange={() => {
                                        dispatch.imageGeneration.setKeepSeed(!keepSeed)
                                    }}
                                />
                                <p className='font-size-10'>Use same seed for the next prompt.</p>
                            </div>
                        </>
                    )}
                </Content>

                <GeneratePromptContainer>
                    <button
                        disabled={!Promt}
                        className={!Promt ? "disabled" : ''}
                        onClick={handlePredict} >Generate Prompt</button>
                </GeneratePromptContainer>
            </>)}

            {/* History Tab */}

            {activeTab === "History" && (<>
                <StatusDropdown />

                <ConversationContainer>
                    {sortedConversations?.map(conversation => {
                        return (
                            <ConversationList
                                key={conversation.id}
                                conversation={conversation}
                                imageHistory={imageHistory}
                                // handleDelete={handleDelete}
                                loading={loading}
                                // handleSelect={handleSelect}
                                // selected={selected}
                                getIcon={getIcon}
                            />
                        );

                    })}
                </ConversationContainer>
            </>)}




        </Container>
    )
}

export default CreateImage

const Container = styled.div`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height: 100%;

    & .padding-15{
        padding: 15px 15px 0px 15px ;
    }

    & .ba-btn{
        font-size: 12px;
        line-height: 18px;
        height: 26px;
    }

     @media only screen and (max-width: 1000px) {
        /* display: none; */
        /* height: 100vh; */
            height: calc(-41px + 100vh);

        /* & .left-sidebar-col{
          display: none !important;
        } */
    }
`

const DimensionButtons = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 6px;
`;

const Button = styled.button`
  border: none;
  background-color: ${({ theme }) => theme.colors.lightgrey};
  color: ${({ theme }) => theme.colors.primary};
  font-size: 10px;
  height: 26px;
  width: 100%;
  border-radius: 4px;
  padding-inline: 10px;
  cursor: pointer;

  &.active {
    background-color: ${({ theme }) => theme.colors.red};
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

const Content = styled.div`
    padding: 15px;

    flex-grow: 1;
    overflow: auto;

    & .temp-selector {
      margin-top: 10px;
    }

    & .gap-10{
        gap: 10px;
    }

    & p {
      margin: 0px;

      &.subtitle {
        opacity: 0.5;
        z-index: 0;
      }
    }
`

const Divider = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.lightgrey};
  margin-block: 12px;
`;

const DividerSpan = styled.div`
  width: 100%;
  margin-block: 30px;
  height: 1px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #ffffff1a;

  & span {
    color: ${({ theme }) => theme.colors.primary};
    line-height: 1;
    background-color: #2E2F33;
    padding-inline: 10px;
    margin-top: -4px;
    font-size: 12px;
    line-height: 18px;
    font-weight: 400;
  }
`;

const TextArea = styled.textarea`
  border: none;
  background-color: #3F4046;
  color: ${({ theme }) => theme.colors.primary};
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  width: 100%;
  border-radius: 8px;
  padding: 10px;
  margin-top: 10px;
  resize: none;
`;

const CustomDimensions = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
`;

const Input = styled.input`
  border: none;
  background-color: #3F4046;
  color: ${({ theme }) => theme.colors.primary};
  font-size: 10px;
  width: 100%;
  height: 40px;
  border-radius: 4px;
  padding: 10px;
  margin-top: 10px;

  &.error {
    border: 1px solid ${({ theme }) => theme.colors.red};
  }
`;

const ImageCountGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6px;
  margin-top: 10px;
`;

const GeneratePromptContainer = styled.div`

    padding: 10px 15px ;
    display: flex;
    align-items: center;
    width: 100%;
    border-top: 1px solid #4D4F56;

    & button {
        background-color: #2292F9;
        color: white;
        width: 100%;
        outline: none;
        border: none;
        border-radius: 8px;
        padding: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        line-height: 24px;
        font-weight: 400;
    }

    & .disabled{
        opacity: 0.5;
        cursor: not-allowed;
    }
`

const ConversationContainer = styled.div`

    flex-grow: 1;
    overflow-y: auto;
`